import React, { useEffect, useState } from 'react'
import Select from 'react-select'

function SelectEvent({ listEvent, onChangeEvent, listEventGroupIdByHost, isDisabled }) {
  const listEventOption = listEventGroupIdByHost?.map((event, index) => ({
    value: index,
    label: event.title,
    id: event.id,
  }))

  const [state, setState] = useState({
    selectedOption: [],
  })

  useEffect(() => {
    setState({
      ...state,
      selectedOption: listEvent,
    })
  }, [listEvent])

  const handleChange = (selectedOption) => {
    setState({ selectedOption })
    onChangeEvent({ selectedOption })
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: '300px',
      backgroundColor: '#fff',
      cursor: isDisabled ? 'default' : 'pointer',
      fontSize: '14px',
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      display: isDisabled ? 'none' : 'flex',
      cursor: isDisabled ? 'default' : 'pointer',
      ':hover': {
        backgroundColor: isDisabled ? 'transparent' : provided.backgroundColor,
        color: isDisabled ? provided.color : provided.color,
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: isDisabled ? 'none' : 'flex',
    }),
    placeholder: (provided) => ({
      ...provided,
      display: isDisabled ? 'none' : 'block',
      color: 'inherit',
    }),
  }

  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      value={listEvent}
      onChange={handleChange}
      options={listEventOption}
      placeholder='Event'
      className='rounded-0 text-orange payment-status'
      isSearchable={!isDisabled}
      isClearable={!isDisabled}
      openMenuOnFocus={!isDisabled}
      openMenuOnClick={!isDisabled}
      tabIndex={isDisabled ? -1 : 0}
      styles={customStyles}
    />
  )
}

export default SelectEvent
